import React from 'react';
import {BrowserRouter} from 'react-router-dom';

import {AppProviders} from 'src/app/app.providers';
import {AppRoutes} from 'src/app/app.routes';
import {NavBar} from 'src/components/nav-bar/nav-bar';
import UpdaterController from 'src/modules/updater/updater.controller';

import {Item} from '@pb/kit-component-group';
import {Page, PageHeader, PageMain, PageNavbar} from '@pb/kit-component-page-v2';
import '@pb/kit-styles-global';

const AppRoot = () => {
    return (
        <BrowserRouter>
            <AppProviders>
                <Page className="page_padding">
                    <PageHeader>
                        <Item style={{width: '100%'}} className="pt-xl pb-xl">
                            <PageNavbar>
                                <NavBar/>
                            </PageNavbar>
                        </Item>
                    </PageHeader>
                    <PageMain>
                        <Item className="pt-s pb-m pdx-xxl">
                            <UpdaterController/>
                            <AppRoutes/>
                        </Item>
                    </PageMain>
                </Page>
            </AppProviders>
        </BrowserRouter>
    );
};

export default AppRoot;
